module.exports = __webpack_public_path__ + "images/emoji/doughnut.527ef22ca28627236056.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/doughnut.png
// module id = jIQE
// module chunks = 2